import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRightIcon } from 'lucide-react';
import { TiltCard } from '../ui/TiltCard';
import { ConsultantPortrait } from './ConsultantPortrait';
import type { Consultant } from '../../types/content';
export function ConsultantCard({
  consultant
}: {
  consultant: Consultant;
}) {
  return <TiltCard className="h-full" data-id="element-51" data-mp="q87fjicmylj3">
      <article className="group relative flex h-full flex-col overflow-hidden rounded-lg border border-line bg-white transition-shadow duration-200 hover:shadow-lift" data-id="element-52" data-mp="1nuethiutxq84">
        <ConsultantPortrait initials={consultant.initials} name={consultant.name} data-id="element-53" data-mp="1iw3jn84jbfpw" />
        <div className="flex flex-1 flex-col p-5" data-id="element-54" data-mp="1e3acyepi9xb6">
          <h3 className="font-display text-2xl font-semibold text-ink" data-id="element-55" data-mp="195s40obhni36">
            <Link to={`/consultants/${consultant.slug}`} className="after:absolute after:inset-0" data-id="element-56" data-mp="193fo0gpajhsr">
              {consultant.name}
            </Link>
          </h3>
          <p className="text-sm text-muted" data-id="element-57" data-mp="21te6tucw6ioz">{consultant.title}</p>
          <p className="mt-3 text-sm text-gold-700" data-id="element-58" data-mp="3h170z1eavp8q">{consultant.focus}</p>
          <span className="mt-auto flex items-center gap-1 pt-5 text-sm font-medium text-royal" data-id="element-59" data-mp="3h3b1d9czq649">
            View profile
            <ArrowUpRightIcon className="h-4 w-4 transition-transform duration-150 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" aria-hidden="true" data-id="element-60" data-mp="37bezdn7s9vur" />
          </span>
        </div>
      </article>
    </TiltCard>;
}